module.exports = __webpack_public_path__ + "static/media/initial.625fb8a8.mp4";